export enum BulkFlashLogActionNames {
  SET_PRE_FLASH_LOG = 'SET_PRE_FLASH_LOG',
  SET_POST_FLASH_LOG = 'SET_POST_FLASH_LOG',
  SET_SIM_CREDENTIALING_FILE = 'SET_SIM_CREDENTIALING_FILE',
  SET_SIM_CREDENTIALING = 'SET_SIM_CREDENTIALING',
  SET_ERROR_LOG_DOWNLOAD_ID = 'SET_ERROR_LOG_DOWNLOAD_ID',
  SET_BATCH_ID = 'SET_BATCH_ID',
  SET_TOTAL_ACCEPTED_DEVICES = 'SET_TOTAL_ACCEPTED_DEVICES',
  SET_LOADING = 'SET_LOADING',
  SET_LOG_TAB = 'SET_LOG_TAB',
  SET_SELECTED_DEVICE = 'SET_SELECTED_DEVICE',
  SET_CSV_TO_UPLOAD = 'SET_CSV_TO_UPLOAD',
  SET_ACTIVE_FILTERS = 'SET_ACTIVE_FILTERS',
  SET_MODEM_FLASH_LOG = 'SET_MODEM_FLASH_LOG',
  SET_MODEM_FLASH_FILE = 'SET_MODEM_FLASH_FILE',
  SET_MODEM_ERROR_LOG_DOWNLOAD_ID = 'SET_MODEM_ERROR_LOG_DOWNLOAD_ID'
}

export enum FlashTabStrings {
  preFlash = 'Pre Flash',
  postFlash = 'Post Flash',
  campaign = 'Campaign',
  simCredentialing = 'SIM Credentialing',
  configAdmin = 'Config Admin',
  modemFlash = 'Modem Flash '
}

type status = { flashStatus: string; flashStatusTime: string };
export interface PreFlashRecord {
  code: string;
  commercialType: string | null;
  configPartNumber: string | null;
  description: string;
  deviceId: string | null;
  deviceKey: string | null;
  deviceType: string | null;
  ecmSerialNumber?: string | null;
  lastCheckInTime: string | null;
  make: string | null;
  preFlashComment?: string | null;
  reportedFirmware?: string | null;
  serialNumber: string | null;
  state: string | null;
  status: status[] | 'N/A' | null;
}

export interface PreFlashLogReports {
  bulkDetails: {
    batchId: string | null;
    failedDevicesDownloadId: string | null;
  };
  totalAcceptedDevices: number;
  preFlashLogs: PreFlashRecord[];
}

export type SelectedDevice = {
  make: string;
  equipmentSN: string;
  deviceId: string;
};

export interface PostFlashRecord extends PreFlashRecord {
  desiredFirmware: string | null;
  postFlashComment: string | null;
  reportedFirmware?: string | null;
  serialNumber: string | null;
  state: string | null;
  statuses: status[] | null;
  manualDevicesToUpload?: SelectedDevice[] | null;
  csvDevicesToUpload?: string | null;
}

export interface SIMCredentialingRecord {
  deviceKey: string;
  country: string;
  description: string;
  recredentialStatus: string;
  lastUpdate: string;
}

export interface SelectedRowsToWakeup {
  make: string | null;
  serialNumber: string | null;
  transactionId: string;
  deviceKey: string | null;
}

export interface PreFlashFilters {
  [key: string]: string[];
}

export interface ErrorFileDownloadIds {
  preFlash: undefined | string;
  postFlash: undefined | string;
}

export interface ModemFlashRecord {
  deviceKey: string,
  deviceId: string,
  status: string,
  code: string,
  description: string,
}

export interface ModemFlashLogRecord {
  modemFirmware:ModemFlashRecord[]
  hash: string,
  transactionId: string,
  userId: string,
  applicationId: string
}

export interface BulkFlashState {
  preFlashLogs: undefined | PreFlashRecord[];
  postFlashLogs: undefined | PostFlashRecord[];
  simCredentialing: undefined | any[];
  simCredentialingFile: undefined | File;
  deviceCommands: undefined | any[];
  errorFileDownloadIds: ErrorFileDownloadIds;
  batchId: undefined | string;
  totalAcceptedDevices: undefined | number;
  loading: boolean | undefined;
  logTab: FlashTabStrings.preFlash | FlashTabStrings.postFlash | FlashTabStrings.campaign | FlashTabStrings.simCredentialing | FlashTabStrings.configAdmin | FlashTabStrings.modemFlash;
  manualDevicesToUpload: SelectedDevice[] | null;
  csvDevicesToUpload: string | null;
  preFlashFilters: PreFlashFilters;
  modemFlashRecord: undefined | ModemFlashRecord[];
  modemFlashFile: undefined | File;
}

interface SetPreFlashLog {
  type: typeof BulkFlashLogActionNames.SET_PRE_FLASH_LOG;
  payload: PreFlashRecord[];
}

interface SetPostFlashLog {
  type: typeof BulkFlashLogActionNames.SET_POST_FLASH_LOG;
  payload: PostFlashRecord[];
}

interface SetSIMCredentialing {
  type: typeof BulkFlashLogActionNames.SET_SIM_CREDENTIALING;
  payload: SIMCredentialingRecord[];
}

interface SetSIMCredentialingFile {
  type: typeof BulkFlashLogActionNames.SET_SIM_CREDENTIALING_FILE;
  payload: File;
}

interface SetErrorLogDownloadId {
  type: typeof BulkFlashLogActionNames.SET_ERROR_LOG_DOWNLOAD_ID;
  payload: ErrorFileDownloadIds;
}

interface SetBatchId {
  type: typeof BulkFlashLogActionNames.SET_BATCH_ID;
  payload: string;
}

interface SetTotalAcceptedDevicesCount {
  type: typeof BulkFlashLogActionNames.SET_TOTAL_ACCEPTED_DEVICES;
  payload: number;
}

interface SetLoading {
  type: typeof BulkFlashLogActionNames.SET_LOADING;
  payload: boolean;
}

interface SetLogTab {
  type: typeof BulkFlashLogActionNames.SET_LOG_TAB;
  payload: FlashTabStrings.preFlash | FlashTabStrings.postFlash;
}

interface SetManualDevicesToUpload {
  type: typeof BulkFlashLogActionNames.SET_SELECTED_DEVICE;
  payload: SelectedDevice[];
}

interface CsvDevicesToUpload {
  type: typeof BulkFlashLogActionNames.SET_CSV_TO_UPLOAD;
  payload: string;
}

interface SetActiveFilters {
  type: typeof BulkFlashLogActionNames.SET_ACTIVE_FILTERS;
  payload: PreFlashFilters;
}

interface setModemFlashRecord{
  type: typeof BulkFlashLogActionNames.SET_MODEM_FLASH_LOG;
  payload: ModemFlashRecord[];
}

interface SetModemFlashFile{
  type:typeof BulkFlashLogActionNames.SET_MODEM_FLASH_FILE;
  payload:File;
}

export type BulkFlashActionTypes =
  | SetPreFlashLog
  | SetPostFlashLog
  | SetSIMCredentialing
  | SetSIMCredentialingFile
  | SetErrorLogDownloadId
  | SetBatchId
  | SetTotalAcceptedDevicesCount
  | SetLoading
  | SetPreFlashLog
  | SetLogTab
  | SetManualDevicesToUpload
  | CsvDevicesToUpload
  | SetActiveFilters
  | setModemFlashRecord
  | SetModemFlashFile;
